import { useNavigate } from "react-router-dom";
import React from "react";
import "./PrivacyUkr.scss";

const PrivacyUkr = () => {
  const navigate = useNavigate();
  return (
    <div className="privacy">
      <div onClick={() => navigate(-1)} className="close">
        Закрити
      </div>
      <h2>Політика конфіденційності</h2>
      <div>
        <p>
          Конфіденційність користувачів нашого веб-сайту має велике значення для
          нас і ми докладаємо всіх зусиль для забезпечення її захисту. Дані
          правила пояснюють як ми використовуємо вашу персональну інформацію.
        </p>
      </div>
      <div>
        <h3>А. Збір персональних даних</h3>
        <p>
          Збору, зберіганню та використанню підлягають наступні типи
          персональних даних:
        </p>
        <ol>
          <li>
            Інформація про ваш комп’ютер, включаючи вашу IP-адресу, географічне
            розташування, тип і версію браузера та операційну систему;
          </li>
          <li>
            Інформація про ваші відвідування та використання цього веб-сайту,
            включаючи реферальні джерела, протяжність візитів, переглянуті
            сторінки та шляхи навігації по сайту;
          </li>
          <li>
            Інформація про адресу вашої електронної пошти, яку ви використали
            для реєстрації на нашому веб-сайті;
          </li>
          <li>
            Інформація, яку ви ввели під час створення профілю на нашому
            веб-сайті – наприклад, ваше ім’я, електронна адреса.
          </li>
          <li>
            Інформація, яку ви ввели під час використання сервісів нашого
            веб-сайту;
          </li>
          <li>
            Інформація, яка генерується при використанні нашого веб-сайту,
            включаючи інформацію про час, частоту та умови його використання;
          </li>
          <li>
            Інформація стосовно використаних сервісів або транзакцій, які ви
            провели через наш веб-сайт, включаючи ваше ім’я, адресу, номер
            телефону, адресу електронної поштової скриньки та інформацію про
            кредитну карту;
          </li>
          <li>
            Інформація, яку ви розмістили на нашому сайті з метою публікації її
            в Інтернеті, включаючи ваше ім’я користувача.
          </li>
          <li>
            Інформація, що міститься в будь-яких повідомленнях, які ви надсилали
            нам електронною поштою або через наш веб-сайт, включаючи зміст
            повідомлення та мета дані;
          </li>
          <li>
            Будь-яка інша персональна інформація, яку ви надіслали нам.Перед
            тим, як розкрити для нас персональну інформацію третьої особи, ви
            маєте отримати згоду цієї особи як на розкриття, так і на обробку
            цієї інформації у відповідності до даних правил.
          </li>
        </ol>
        <p>
          Перед тим, як розкрити для нас персональну інформацію третьої особи,
          ви маєте отримати згоду цієї особи як на розкриття, так і на обробку
          цієї інформації у відповідності до даних правил.
        </p>
      </div>
      <div>
        <h3>Б. Використання вашої персональної інформації</h3>
        <p>
          Персональна інформація, яку ви передані нам через наш веб-сайт, буде
          використовуватися задля цілей, зазначених в цих правилах або на
          відповідних сторінках веб-сайту. Ми можемо використовувати вашу
          персональну інформацію в наступних цілях:
        </p>
        <ol>
          <li>адміністрування нашого веб-сайту;</li>
          <li>персоналізація нашого веб-сайту для вас;</li>
          <li>
            надання вам можливості користуватися сервісами, доступними на нашому
            веб-сайті;
          </li>
          <li>надання вам послуг, придбаних через наш веб-сайт;</li>
          <li>
            надсилання вам повідомлень, рахунків та нагадувань про сплату, та
            отримання платежів від вас;
          </li>
          <li>надсилання вам немаркетингових комерційних повідомлень;</li>
          <li>
            надсилання вам електронною поштою повідомлень, які ви спеціально
            запросили;
          </li>
          <li>
            надсилання вам електронної розсилки, якщо ви її замовили (ви в
            будь-який момент можете повідомити нас, що більше не бажаєте
            отримувати електронні розсилки від нас);
          </li>
          <li>
            надсилання вам маркетингових повідомлень стосовно нашої ділової
            активності або ділової активності старанно відібраних сторонніх
            компаній, яка, на нашу думку, може вас зацікавити, шляхом публікацій
            або, якщо ви конкретно надали на це згоду – шляхом надсилання
            електронної пошти або за рахунок використання подібних технологій
            (ви в будь-який момент можете повідомити нас, що більше не бажаєте
            отримувати маркетингові повідомлення);
          </li>
          <li>
            надання стороннім компаніям статистичної інформації про наших
            користувачів (проте, ці сторонні компанії не матимуть змоги
            ідентифікувати жодного окремого користувача з цих даних);
          </li>
          <li>
            обробка запитів та скарг, зроблених вами або на вас, і які
            стосуються нашого веб-сайту;
          </li>
          <li>
            з метою забезпечення безпеки нашого сайту та попередження
            шахрайства;
          </li>
          <li>
            з метою перевірки відповідності умовам та правилам, які
            регламентують використання нашого веб-сайту (включаючи моніторинг
            приватних повідомлень, надісланих через сервіс приватних повідомлень
            нашого веб-сайту); та
          </li>
          <li>в інших цілях.</li>
        </ol>
      </div>
      <div>
        <h3>В. Розкриття персональної інформації</h3>
        <p>
          Ми лишаємо за собою право розкрити вашу персональну інформацію для
          будь-якого з наших працівників, керівників, страхувальників,
          професійних радників, агентів, постачальників або субпідрядників, в
          об’ємі та цілях, визначених в цих правилах.
        </p>
        <p>Ми лишаємо за собою право розкрити вашу персональну інформацію:</p>
        <ol>
          <li>в тих випадках, в яких цього від нас вимагає закон;</li>
          <li>
            у зв’язку з будь-яким поточними або майбутніми судовими процесами;
          </li>
          <li>
            з метою встановлення, реалізації або захисту наших законних прав
            (включаючи надання інформації іншим сторонам задля запобігання
            шахрайству або зниження кредитних ризиків);
          </li>
          <li>
            будь-якій особі, яка, як ми обґрунтовано вважаємо, може подати запит
            до суду або іншого уповноваженого органу про розкриття цих
            персональних даних і, на нашу обґрунтовану думку, цей суд або
            уповноважений орган видасть розпорядження на розкриття цих
            персональних даних.
          </li>
        </ol>
        <p>
          Ми не будемо розкривати вашу персональну інформацію третім особам, за
          виключенням випадків, зазначених в цих правилах.
        </p>
      </div>
      <div>
        <h3>Г. Міжнародні передачі персональної інформації</h3>
        <ol>
          <li>
            Інформація, яку ми збираємо, може зберігатися, оброблятися та
            передаватися між будь-якими країнами, в яких ми здійснюємо свою
            діяльність, з метою надання нам можливості використовувати цю
            інформацію у відповідності з цими правилами.
          </li>
          <li>
            Інформація, яку ми збираємо, може бути передана в наступні країни,
            де немає законів із захисту даних, аналогічних тим, що діють на
            території Європейської Економічної Зони: США, Росія, Японія, Китай
            та Індія.
          </li>
          <li>
            Персональна інформація, які ви публікуєте на нашому веб-сайті, через
            Інтернет, може бути доступна в усьому світі. Ми не можемо
            перешкодити її використанню, або неправомірному використанню в
            злочинних цілях, сторонніми особами.
          </li>
          <li>
            Погоджуючись з цими правилами, ви надаєте згоду на передачу вашої
            персональної інформації, зазначеної в розділі Е.
          </li>
        </ol>
      </div>
      <div>
        <h3>Д. Збереження персональної інформації</h3>
        <ol>
          <li>
            Розділ Є встановлює правила та процедури компанії щодо збереження
            персональної інформації. Дані правила та процедури призначені для
            забезпечення виконання нами наших юридичних зобов’язань щодо
            збереження та видалення персональної інформації.
          </li>
          <li>
            Персональна інформація, яку ми обробляємо з певною метою або в
            певних цілях не повинна зберігатися довше, ніж потрібно для
            досягнення цієї мети або цих цілей.
          </li>
          <li>
            Без обмежень положень, зазначених в пункті Є-2, ми зазвичай
            видаляємо персональну інформацію за бажанням користувача.
          </li>
          <li>
            персональна інформація буде видалена, коли ви вирішите видалити свій
            аккаунт на нашому сайті.
          </li>
        </ol>
      </div>
      <div>
        <h3>Є. Захист вашої персональної інформації</h3>
        <ol>
          <li>
            Ми будемо вживати достатні технічні та організаційні заходи для
            попередження втрати, протиправного використання чи підробки вашої
            персональної інформації.
          </li>
          <li>
            Всю надану вами персональну інформацію ми будемо зберігати на наших
            захищених (як паролем, так і фаєрволами) серверах.
          </li>
          <li>
            Всі електронні фінансові транзакції, здійснені за допомогою нашого
            сайту, будуть захищені технологією шифрування даних.
          </li>
          <li>
            Ви підтверджуєте своє ознайомлення з тим фактом, що передача
            інформації через Інтернет є по суті є незахищеною, і ми не можемо
            гарантувати захист даних, надісланих через всесвітню мережу.
          </li>
          <li>
            Ви несете повну відповідальність за збереження свого пароля для
            доступу на наш веб-сайт в таємниці. Ми ніколи не будемо запитувати
            ваш пароль (за виключенням випадків, коли ви намагаєтесь увійти до
            свого облікового запису на нашому сайті).
          </li>
        </ol>
      </div>
      <div>
        <h3>Ж. Зміни та поправки</h3>
        <p>
          Ми лишаємо за собою право періодично вносити зміни та поправки в ці
          правила, та публікувати їх нову редакцію на нашому сайті. Ви повинні
          періодично перевіряти цю веб-сторінку, щоб пересвідчитись, що
          розумієте зміст змін, внесених до цих правил. Ми також можемо
          проінформувати вас про внесення змін до цих правил шляхом надсилання
          електронної пошти або через систему передачі приватних повідомлень
          нашого сайту.
        </p>
      </div>
      <div>
        <h3>З. Ваші права</h3>
        <p>
          Ви можете надати нам вказівку надавати вам будь-яку персональну
          інформацію про вас, яку ми маємо; надання такої інформації буде
          здійснюватись в наступних випадках:
        </p>
        <ol>
          <li>оплата підписки;</li>
        </ol>
        <p>
          Ми лишаємо за собою право відмовити в наданні інформації за вашим
          запитом, в межах чинного законодавства.
        </p>
      </div>
      <div>
        <h3>И. Сторонні веб-сайти</h3>
        <p>
          Наш веб-сайт містить гіперпосилання на, та деталі про веб-сайти
          сторонніх компаній та осіб. Ми не маємо інструментів керування, та не
          несемо відповідальності за політику конфіденційності й практики
          сторонніх осіб та компаній в цій галузі.
        </p>
      </div>
      <div>
        <h3>І. Оновлення інформації</h3>
        <p>
          Ви можете оновити свою персональну інформацію на нашому сайті
          самостійно.
        </p>
      </div>
      <div>
        <h3>Ї. Файли-Cookies</h3>
        <p>Наш сайт не використовує файли-cookies</p>
      </div>
    </div>
  );
};

export default PrivacyUkr;
